"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneDetailsCms = void 0;
var PhoneDetailsCms = /** @class */ (function () {
    function PhoneDetailsCms() {
        this.lineLabel = 'Line';
        this.lineNameLabel = "'S LINE";
        this.editLinkLabel = 'Edit';
        this.editLinkAriaLabel = 'Edit number selection';
        this.yourDeviceLabel = 'Your device';
        this.firstNetLineNameLabel = "'S firstnet Line";
        this.firstNetLineLabel = 'firstnet Line';
    }
    return PhoneDetailsCms;
}());
exports.PhoneDetailsCms = PhoneDetailsCms;
//# sourceMappingURL=PhoneDetails.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeviceOptionsPanel/DeviceCard/PhoneDetails/PhoneDetails.cms.js
// module id = 2007
// module chunks = 8